import {
    WidgetStrategyWithConfig,
    WidgetStrategyWithCustomManagedStream,
} from 'widgets/WidgetRegistry';
import { WidgetCategory } from 'widgets/WidgetCategory';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import VolumeCurve from 'widgets/volumeCurve/components/VolumeCurve.tsx';
import { buildVolumeCurveConfigSlice } from 'widgets/volumeCurve/store/configuration/configSlice.ts';
import { VolumeCurveConfiguration } from 'widgets/volumeCurve/store/configuration/VolumeCurveConfiguration.ts';
import { volumeCurveStreamConfig } from 'widgets/volumeCurve/store/data/stream-config.ts';
import { volumeCurveDescription } from 'widgets/volumeCurve/components/help/volumeCurveDescription.tsx';

const { initialConfigState } = buildVolumeCurveConfigSlice();

export const volumeCurveStrategy: WidgetStrategyWithConfig<VolumeCurveConfiguration> &
    WidgetStrategyWithCustomManagedStream = {
    title: 'Volume Curve',
    supportedHosts: ['layout'],
    initialConfigState,
    reactComponentType: VolumeCurve,
    description: volumeCurveDescription,
    categories: [WidgetCategory.SINGLE_STOCK],
    requiredAuthorities: [],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.ExactlyOneOrder,
    managedStreamConfig: volumeCurveStreamConfig,
    getRequiredOrderColumns: () => ['timeIn'],
};
